import { GetterTree } from "vuex";
import { SettingsState } from "@/legacy/store/settings/state";
import RootState from "@/legacy/store/rootState";
import { SettingsGettersType } from "@/legacy/store/settings/contract";
import { TenantSettings } from "@/legacy/models/settings";

const getters: GetterTree<SettingsState, RootState> = {};
getters[SettingsGettersType.GetSettings] = (settingsState: SettingsState): TenantSettings => ({ ...settingsState });
export default getters;
